import { Injectable } from "@angular/core";
import { ICellRendererParams } from "ag-grid-community";
import { BehaviorSubject, Observable, Subject, catchError, tap, throwError } from "rxjs";
import { DataService } from "../../services/data.service";
import { ResponseModel } from "../../models/response-model.model";
import { AgColDefsI, Filters, Operations, SendNotification, Updategridcolumndefinition, areFieldsRequired, defaultPageLimit } from "./ag-grid.model";
import { StorageService } from "../../services/storage.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { StorageName } from "../../enum/common-enum";
import { SubscriptionListService } from "src/app/components/subscription/subscription-list/subscription-list.service";

@Injectable(
  {
  providedIn: "root",
})
export class AgGridService {
  public gridColumnApi = new BehaviorSubject(undefined);
  public gridApi = new BehaviorSubject(undefined);
  public preview = new BehaviorSubject(undefined);
  selectionChanged = new Subject();


  public onTextClickedSource = new Subject<any>();
  onTextClicked$ = this.onTextClickedSource.asObservable();

  public onRadioButtonSource = new Subject<any>();
  onRadioButtonChange$ = this.onRadioButtonSource.asObservable();

  public selectedDateSource = new Subject<any>();
  selectedDateChange$ = this.selectedDateSource.asObservable();
  constructor(public service: DataService,public storageService: StorageService,private modalService: NgbModal, public subscriptionListService:SubscriptionListService) {}
  public addRowSource = new Subject<any>();
  addRowSourceChange$ = this.addRowSource.asObservable();
  cameraButtonDisabled:boolean=false;


  getGridApi() {
    return this.gridApi.getValue();
  }

  setGridApi(gridApi) {
    this.gridApi.next(gridApi);
  }

  getGridColumnApi() {
    return this.gridColumnApi.getValue();
  }

  setGridColumnApi(gridColumnApi) {
    this.gridColumnApi.next(gridColumnApi);
  }

  triggerOnTextClick(data: any) {
    this.onTextClickedSource.next(data);
  }

  onChangeRadioSelected(data: any) {
    this.onRadioButtonSource.next(data);
  }

  onChangeSelectedDates(selectedDates, data: ICellRendererParams) {
    this.selectedDateSource.next({ selectedDates: selectedDates, data: data });
  }

  addRowInGrid(parmas:any){
    this.addRowSource.next(parmas)
  }

  appendNewRow(gridApi, data = undefined){
    if(gridApi != undefined){
      if(data == undefined)
      data = {
        quantity : 1,
        added : true,
        edited : false,
        deleted : false,
        purityPer : '1.0'
      }
      var defaultAddObject = data;
      gridApi.api.applyTransaction({ add: [defaultAddObject] });
      // this.addRowInGrid(gridApi)

      let lastrow = gridApi.api.getDisplayedRowAtIndex(gridApi.api.getLastDisplayedRow());
      // scrolls to the first column, or first editable column. you can pass in the correct index
      var firstEditCol = gridApi.columnApi.getAllDisplayedColumns()[0];
      /////
      gridApi.api.ensureColumnVisible(firstEditCol );

      // sets focus into the first grid cell
      gridApi.api.setFocusedCell(lastrow.rowIndex, firstEditCol); 

      gridApi.api.startEditingCell({
        rowIndex: lastrow.rowIndex,
        colKey:firstEditCol.colId
      });
      //  var checkLastRowNode = lastrow;
    }
  }


  

  handleError(err: any): any {
    throw new Error("Method not implemented.");
  }

  insertUpdatePDCVoucherData(data:any){
    let url = `api/App/Subscription/getAllSubscription`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  getAllDropdownList() {
    let url = `api/App/Dropdown/getAllDropdown`;
    return this.service.get(url, true).pipe<ResponseModel>(tap((response: any) => {
      var getAllDropdown = response.response;
      this.storageService.store(StorageName.PLAN_DROPDOWN, getAllDropdown.plansDropdown);
      this.storageService.store(StorageName.ACCOUNT_DROPDOWN, getAllDropdown.accountDropdown);
      this.storageService.store(StorageName.CITY_DROPDOWN, getAllDropdown.cityDropdown);
      this.storageService.store(StorageName.COUNTRY_DROPDOWN, getAllDropdown.countryDropdown);
      this.storageService.store(StorageName.STATE_DROPDOWN, getAllDropdown.stateDropdown);
      this.storageService.store(StorageName.STATUS_DROPDOWN, getAllDropdown.statusDropdown);
      this.storageService.store(StorageName.DATE_RANGE_DROPDOWN, getAllDropdown.dateRangeDropdown);
      this.storageService.store(StorageName.USER_DROPDOWN, getAllDropdown.userDropdown);
      this.storageService.store(StorageName.ACCOUNT_LEDGER_DROPDOWN, getAllDropdown.accountLedgerDropdown);
      this.storageService.store(StorageName.PAYMENT_TYPE_DROPDOWN, getAllDropdown.paymentTypeDropdown);
      this.storageService.store(StorageName.DEPOSIT_INTO_DROPDOWN, getAllDropdown.depositIntoDropdown);
      this.storageService.store(StorageName.AGAINST_DROPDOWN, getAllDropdown.againstDropdown);
      this.storageService.store(StorageName.TRANSFER_FROM_DROPDOWN, getAllDropdown.transferFromDropdown);
      this.storageService.store(StorageName.PLAN_TYPE_DROPDOWN, getAllDropdown.planTypeDropdown);
      this.storageService.store(StorageName.SUBSCRIPTION_STATUS_DROPDOWN, getAllDropdown.subscriptionStatusDropdown);
      this.storageService.store(StorageName.EXPIRED_MONTH_DROPDOWN, getAllDropdown.expiredMonthDropdown);
      this.storageService.store(StorageName.SALSEPERSON_DROPDOWN, getAllDropdown.salesPersonDropdown);
      this.storageService.store(StorageName.MARKETING_CATEGORY_DROPDOWN, getAllDropdown.marketingCategoryDropdown);
      this.storageService.store(StorageName.INSTALL_FROM_DROPDOWN, getAllDropdown.installFromDropdown);
      this.storageService.store(StorageName.NOTIFICATION_TYPE_DROPDOWN, getAllDropdown.notificationType);
      this.storageService.store(StorageName.NOTIFICATION_LANGUAGE_DROPDOWN, getAllDropdown.notificationLanguage);
      this.storageService.store(StorageName.ISSUE_RESOLVED_DROPDOWN, getAllDropdown.issueResolved);
      this.storageService.store(StorageName.INSTALLATION_CHECKLIST_STATUS_DROPDOWN, getAllDropdown.installationChecklistStatus);
      this.storageService.store(StorageName.INSTALLATION_CHECKLIST_ITEM_TYPE_DROPDOWN, getAllDropdown.installationChecklistItemType);
      this.storageService.store(StorageName.TRAINING_STATUS_DROPDOWN, getAllDropdown.trainingStatus);
      this.storageService.store(StorageName.PLAN_MASTER_DROPDOWN, getAllDropdown.plansDropdown);
      this.storageService.store(StorageName.SOFTWARE_PLAN_DROPDOWN, getAllDropdown.softwarePlan);
      // this.storageService.store(StorageName.ADMIN_SEND_WHATSAPP_USER_DROPDOWN, getAllDropdown.adminSendWhatsAppUserList);
      // this.storageService.store(StorageName.ADMIN_SEND_WHATSAPP_USER_PHONE_DROPDOWN, getAllDropdown.adminSendWhatsAppUserPhoneList);
      // this.storageService.store(StorageName.ADMIN_SEND_WHATSAPP_USER_SHOP_NAME_DROPDOWN, getAllDropdown.adminSendWhatsAppUserShopNameList);
      this.storageService.store(StorageName.CONATACT_LIST_DROPDOWN, getAllDropdown.contactNoListDropdown);
      
      return response;
    })
    );
  }

  // updateColumnValues(params:any,values:any=[],fieldName:string=''){
  //   const column = params?.columnApi?.getColumn(fieldName);
  //   if (column) {
  //     column.getColDef().cellEditorParams = {
  //       values: () => {
  //                  return values
  //                 }
  //     };
  //     // params.columnApi.setColumnState(params?.columnApi?.getColumnState());
  //     params.api.refreshCells({ columns: [fieldName], force: true });
  //   }
  // }

  updateColumnValues(params: any, values: any[] = [], fieldName: string = '', rowIndex?: number) {
  const column = params?.columnApi?.getColumn(fieldName);
  if (column) {
    column.getColDef().cellEditorParams = {
      values: () => values
    };
    if (rowIndex !== undefined) {
      const rowNode = params.api.getDisplayedRowAtIndex(rowIndex);
      if (rowNode) {
        params.api.refreshCells({ rowNodes: [rowNode], columns: [fieldName], force: true });
      }
    } else {
      params.api.refreshCells({ columns: [fieldName], force: true });
    }
  }
}

  
  
  sendNotification(data:SendNotification){
    let url = `api/App/Notification/sendNotification`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

}
